import React from "react";
import DownloadJornaleiroAndroidImg from "../assets/images/jornaleiro/download-android.jpg";
import DownloadJornaleiroIosImg from "../assets/images/jornaleiro/download-iphone.jpg";
import DownloadBebancaAndroidImg from "../assets/images/bebanca/download-android.jpg";
import DownloadBebancaIosImg from "../assets/images/bebanca/download-iphone.jpg";
import DownloadBegamerAndroidImg from "../assets/images/begamer/download-android.jpg";
import DownloadBegamerIosImg from "../assets/images/begamer/download-iphone.jpg";
import HomeBebancaBanner from "../assets/images/bebanca/home-banner.png";
import HomeJornaleiroBanner from "../assets/images/jornaleiro/home-banner.png";

const mapDomainsToName = {
  "bebanca.com.br": "bebanca",
  "www.bebanca.com.br": "bebanca",
  "accounts.bebanca.com.br": "bebanca",
  "jornaleironaweb.com.br": "jornaleiro",
  "www.jornaleironaweb.com.br": "jornaleiro",
  "accounts.jornaleironaweb.com.br": "jornaleiro",
  "begamer.app": "begamer",
  "www.begamer.app": "begamer",
  "accounts.begamer.app": "begamer",
  "localhost:3001": "bebanca"
};

export const siteName = mapDomainsToName[window.location.host] || "bebanca";

const sites = {
  bebanca: {
    name: "Bebanca",
    contactEmail: "contato@bebanca.com.br",
    home: {
      imgBanner: (
        <img
          src={HomeBebancaBanner}
          width="100%"
          alt="A experiencia de se informar sobre o mundo na palma da mão."
          title="A experiencia de se informar sobre o mundo na palma da mão."
        />
      )
    },
    download: {
      url: "https://lp.bebanca.app/download/",
      android: {
        img: <img src={DownloadBebancaAndroidImg} alt="" title="" />,
        store:
          "https://play.google.com/store/apps/details?id=com.bebanca&hl=pt_BR"
      },
      ios: {
        img: <img src={DownloadBebancaIosImg} alt="" title="" />,
        store: "https://itunes.apple.com/br/app/bebanca/id1349933503?mt=8"
      }
    },
    assinatura: {
      url: "http://www.bebanca.com.br/assine"
    },
    links: {
      duvidas: "/duvidas",
      politicaDePrivacidade: "/politica-de-privacidade",
      termosDeUso: "/termos-de-uso"
    }
  },
  jornaleiro: {
    name: "Jornaleiro",
    contactEmail: "contato@jornaleironaweb.com.br",
    home: {
      imgBanner: <img src={HomeJornaleiroBanner} width="95%" alt="" title="" />
    },
    download: {
      url: "https://www.jornaleironaweb.com.br/",
      android: {
        img: <img src={DownloadJornaleiroAndroidImg} alt="" title="" />,
        store:
          "https://play.google.com/store/apps/details?id=com.bebanca.jornaleiro&hl=pt_BR"
      },
      ios: {
        img: <img src={DownloadJornaleiroIosImg} alt="" title="" />,
        store: "https://itunes.apple.com/br/app/jornaleiro/id1415215041?mt=8"
      }
    },
    assinatura: {
      url: "http://www.jornaleironaweb.com.br/assinatura-nextel/"
    },
    links: {
      duvidas: "/duvidas",
      politicaDePrivacidade: "/politica-de-privacidade",
      termosDeUso: "/termos-de-uso"
    }
  },
  begamer: {
    name: "Begamer",
    contactEmail: "contato@begamer.app",
    home: {
      imgBanner: <img src={HomeJornaleiroBanner} width="95%" alt="" title="" />
    },
    download: {
      url: "https://www.begamer.app/download/",
      android: {
        img: <img src={DownloadBegamerAndroidImg} alt="" title="" />,
        store:
          "https://play.google.com/store/apps/details?id=com.bebanca.begamer"
      },
      ios: {
        img: <img src={DownloadBegamerIosImg} alt="" title="" />,
        store: "https://apps.apple.com/br/app/begamer/id1471228906"
      }
    },
    assinatura: {
      url: "http://www.begamer.app"
    },
    links: {
      duvidas: "https://www.begamer.app/duvidas/",
      politicaDePrivacidade: "https://www.begamer.app/politica-de-privacidade/",
      termosDeUso: "https://www.begamer.app/termos-de-uso/"
    }
  }
};

export const siteParams = sites[siteName];



// WEBPACK FOOTER //
// ./src/config/site.js